import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ArticleSearchQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name' | 'rendered'>
);

export type ArticleSearchQuery_search_ItemSearchResults_results = ArticleSearchQuery_search_ItemSearchResults_results_Accordion | ArticleSearchQuery_search_ItemSearchResults_results_AccordionFolder | ArticleSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | ArticleSearchQuery_search_ItemSearchResults_results_AccordionItem | ArticleSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | ArticleSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_AccordionPresentation | ArticleSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder | ArticleSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | ArticleSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | ArticleSearchQuery_search_ItemSearchResults_results_AddItem | ArticleSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | ArticleSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | ArticleSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | ArticleSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | ArticleSearchQuery_search_ItemSearchResults_results_AddThisParameters | ArticleSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter | ArticleSearchQuery_search_ItemSearchResults_results_AlertMessage | ArticleSearchQuery_search_ItemSearchResults_results_AlertMessageFolder | ArticleSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_AlertMessageType | ArticleSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_Archive | ArticleSearchQuery_search_ItemSearchResults_results_ArticleAuthor | ArticleSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleCategory | ArticleSearchQuery_search_ItemSearchResults_results_ArticleChapter | ArticleSearchQuery_search_ItemSearchResults_results_ArticleChapters | ArticleSearchQuery_search_ItemSearchResults_results_ArticleContentType | ArticleSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleFilter | ArticleSearchQuery_search_ItemSearchResults_results_ArticleFilterOption | ArticleSearchQuery_search_ItemSearchResults_results_ArticleFootnote | ArticleSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink | ArticleSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText | ArticleSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile | ArticleSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_ArticlePage | ArticleSearchQuery_search_ItemSearchResults_results_ArticleRegion | ArticleSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSettings | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | ArticleSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleTag | ArticleSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder | ArticleSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor | ArticleSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | ArticleSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | ArticleSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder | ArticleSearchQuery_search_ItemSearchResults_results_AttachThemeExtension | ArticleSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings | ArticleSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings | ArticleSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings | ArticleSearchQuery_search_ItemSearchResults_results_AvailableRenderings | ArticleSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | ArticleSearchQuery_search_ItemSearchResults_results_AwardsBanner | ArticleSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder | ArticleSearchQuery_search_ItemSearchResults_results_AwardsBannerImage | ArticleSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_BackgroundColorOption | ArticleSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | ArticleSearchQuery_search_ItemSearchResults_results_BannerFolder | ArticleSearchQuery_search_ItemSearchResults_results_BannerType | ArticleSearchQuery_search_ItemSearchResults_results_BannerTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_BaseHeading | ArticleSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder | ArticleSearchQuery_search_ItemSearchResults_results_BoolFacet | ArticleSearchQuery_search_ItemSearchResults_results_BranchesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Breadcrumb | ArticleSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition | ArticleSearchQuery_search_ItemSearchResults_results_CORSEntry | ArticleSearchQuery_search_ItemSearchResults_results_CORSGrouping | ArticleSearchQuery_search_ItemSearchResults_results_CTAPresentationType | ArticleSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__AbrdnPage | ArticleSearchQuery_search_ItemSearchResults_results_C__ActionBase | ArticleSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter | ArticleSearchQuery_search_ItemSearchResults_results_C__App | ArticleSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | ArticleSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_C__BaseCTA | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | ArticleSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | ArticleSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_C__BaseTheme | ArticleSearchQuery_search_ItemSearchResults_results_C__BaseVariantField | ArticleSearchQuery_search_ItemSearchResults_results_C__Class | ArticleSearchQuery_search_ItemSearchResults_results_C__CompositeGroup | ArticleSearchQuery_search_ItemSearchResults_results_C__CompositeSection | ArticleSearchQuery_search_ItemSearchResults_results_C__EloquaForm | ArticleSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | ArticleSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions | ArticleSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | ArticleSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | ArticleSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | ArticleSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | ArticleSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | ArticleSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | ArticleSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | ArticleSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | ArticleSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | ArticleSearchQuery_search_ItemSearchResults_results_C__GridDefinition | ArticleSearchQuery_search_ItemSearchResults_results_C__GridItemBase | ArticleSearchQuery_search_ItemSearchResults_results_C__GridParameters | ArticleSearchQuery_search_ItemSearchResults_results_C__HeadlessSite | ArticleSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant | ArticleSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | ArticleSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | ArticleSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | ArticleSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty | ArticleSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | ArticleSearchQuery_search_ItemSearchResults_results_C__IBoosting | ArticleSearchQuery_search_ItemSearchResults_results_C__ICacheable | ArticleSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | ArticleSearchQuery_search_ItemSearchResults_results_C__IComponentVariant | ArticleSearchQuery_search_ItemSearchResults_results_C__IControlType | ArticleSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | ArticleSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | ArticleSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | ArticleSearchQuery_search_ItemSearchResults_results_C__IIcon | ArticleSearchQuery_search_ItemSearchResults_results_C__ILocation | ArticleSearchQuery_search_ItemSearchResults_results_C__IPaginable | ArticleSearchQuery_search_ItemSearchResults_results_C__IPagination | ArticleSearchQuery_search_ItemSearchResults_results_C__IPoi | ArticleSearchQuery_search_ItemSearchResults_results_C__IRenderingId | ArticleSearchQuery_search_ItemSearchResults_results_C__ISplitter | ArticleSearchQuery_search_ItemSearchResults_results_C__IStyling | ArticleSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition | ArticleSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | ArticleSearchQuery_search_ItemSearchResults_results_C__JSONField | ArticleSearchQuery_search_ItemSearchResults_results_C__JSONReference | ArticleSearchQuery_search_ItemSearchResults_results_C__JSSData | ArticleSearchQuery_search_ItemSearchResults_results_C__JSSSettings | ArticleSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__JssRootFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | ArticleSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | ArticleSearchQuery_search_ItemSearchResults_results_C__Page | ArticleSearchQuery_search_ItemSearchResults_results_C__PageData | ArticleSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | ArticleSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesign | ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | ArticleSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | ArticleSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | ArticleSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | ArticleSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | ArticleSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | ArticleSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | ArticleSearchQuery_search_ItemSearchResults_results_C__Route | ArticleSearchQuery_search_ItemSearchResults_results_C__SimpleVideo | ArticleSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__SitemapSettings | ArticleSearchQuery_search_ItemSearchResults_results_C__StandardTemplate | ArticleSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | ArticleSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | ArticleSearchQuery_search_ItemSearchResults_results_C__TrustFolder | ArticleSearchQuery_search_ItemSearchResults_results_C__VariantDefinition | ArticleSearchQuery_search_ItemSearchResults_results_C__VariantField | ArticleSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping | ArticleSearchQuery_search_ItemSearchResults_results_C___AdvancedItem | ArticleSearchQuery_search_ItemSearchResults_results_C___Arguments | ArticleSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | ArticleSearchQuery_search_ItemSearchResults_results_C___Article | ArticleSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | ArticleSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseArticle | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePage | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePageDesign | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePresentation | ArticleSearchQuery_search_ItemSearchResults_results_C___BasePressRelease | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSettings | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseTenant | ArticleSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___BucketRules | ArticleSearchQuery_search_ItemSearchResults_results_C___CORS | ArticleSearchQuery_search_ItemSearchResults_results_C___Content | ArticleSearchQuery_search_ItemSearchResults_results_C___ContentType | ArticleSearchQuery_search_ItemSearchResults_results_C___DataAttributes | ArticleSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | ArticleSearchQuery_search_ItemSearchResults_results_C___Dependencies | ArticleSearchQuery_search_ItemSearchResults_results_C___Description | ArticleSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | ArticleSearchQuery_search_ItemSearchResults_results_C___Designable | ArticleSearchQuery_search_ItemSearchResults_results_C___EditType | ArticleSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | ArticleSearchQuery_search_ItemSearchResults_results_C___EditingTheme | ArticleSearchQuery_search_ItemSearchResults_results_C___Enabled | ArticleSearchQuery_search_ItemSearchResults_results_C___ErrorHandling | ArticleSearchQuery_search_ItemSearchResults_results_C___ExternalArticle | ArticleSearchQuery_search_ItemSearchResults_results_C___Fields | ArticleSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | ArticleSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___Footnotes | ArticleSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability | ArticleSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage | ArticleSearchQuery_search_ItemSearchResults_results_C___FundSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_C___FundsFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___GridMapping | ArticleSearchQuery_search_ItemSearchResults_results_C___HelpArticle | ArticleSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | ArticleSearchQuery_search_ItemSearchResults_results_C___Icon | ArticleSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault | ArticleSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | ArticleSearchQuery_search_ItemSearchResults_results_C___InternalArticle | ArticleSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | ArticleSearchQuery_search_ItemSearchResults_results_C___IsSystemModule | ArticleSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging | ArticleSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase | ArticleSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay | ArticleSearchQuery_search_ItemSearchResults_results_C___LinkAttributes | ArticleSearchQuery_search_ItemSearchResults_results_C___LinkSettings | ArticleSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation | ArticleSearchQuery_search_ItemSearchResults_results_C___MemberOf | ArticleSearchQuery_search_ItemSearchResults_results_C___MetadataPage | ArticleSearchQuery_search_ItemSearchResults_results_C___Modules | ArticleSearchQuery_search_ItemSearchResults_results_C___Name | ArticleSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | ArticleSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | ArticleSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | ArticleSearchQuery_search_ItemSearchResults_results_C___Navigable | ArticleSearchQuery_search_ItemSearchResults_results_C___NavigablePage | ArticleSearchQuery_search_ItemSearchResults_results_C___PageContent | ArticleSearchQuery_search_ItemSearchResults_results_C___PageWorkflow | ArticleSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | ArticleSearchQuery_search_ItemSearchResults_results_C___Podcast | ArticleSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease | ArticleSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage | ArticleSearchQuery_search_ItemSearchResults_results_C___PressRelease | ArticleSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType | ArticleSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme | ArticleSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | ArticleSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | ArticleSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | ArticleSearchQuery_search_ItemSearchResults_results_C___RenderingsList | ArticleSearchQuery_search_ItemSearchResults_results_C___RobotsContent | ArticleSearchQuery_search_ItemSearchResults_results_C___RoleDomain | ArticleSearchQuery_search_ItemSearchResults_results_C___RoleName | ArticleSearchQuery_search_ItemSearchResults_results_C___RoleType | ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId | ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | ArticleSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | ArticleSearchQuery_search_ItemSearchResults_results_C___Script | ArticleSearchQuery_search_ItemSearchResults_results_C___SearchSignature | ArticleSearchQuery_search_ItemSearchResults_results_C___Searchable | ArticleSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedArticles | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedContent | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedPage | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedRoot | ArticleSearchQuery_search_ItemSearchResults_results_C___SharedSettings | ArticleSearchQuery_search_ItemSearchResults_results_C___SiteContent | ArticleSearchQuery_search_ItemSearchResults_results_C___SiteFolder | ArticleSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | ArticleSearchQuery_search_ItemSearchResults_results_C___SiteSettings | ArticleSearchQuery_search_ItemSearchResults_results_C___SiteTemplate | ArticleSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | ArticleSearchQuery_search_ItemSearchResults_results_C___Sitemap | ArticleSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems | ArticleSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | ArticleSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | ArticleSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | ArticleSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName | ArticleSearchQuery_search_ItemSearchResults_results_C___SortOrder | ArticleSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint | ArticleSearchQuery_search_ItemSearchResults_results_C___Statistics | ArticleSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages | ArticleSearchQuery_search_ItemSearchResults_results_C___Taggable | ArticleSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | ArticleSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | ArticleSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle | ArticleSearchQuery_search_ItemSearchResults_results_C___Template | ArticleSearchQuery_search_ItemSearchResults_results_C___Title | ArticleSearchQuery_search_ItemSearchResults_results_C___Type | ArticleSearchQuery_search_ItemSearchResults_results_C___Validation | ArticleSearchQuery_search_ItemSearchResults_results_C___VariantPaging | ArticleSearchQuery_search_ItemSearchResults_results_C___VectorTile | ArticleSearchQuery_search_ItemSearchResults_results_C___VectorTileLink | ArticleSearchQuery_search_ItemSearchResults_results_C___Video | ArticleSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease | ArticleSearchQuery_search_ItemSearchResults_results_C___Width | ArticleSearchQuery_search_ItemSearchResults_results_C___WildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_CacheSetting | ArticleSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | ArticleSearchQuery_search_ItemSearchResults_results_CalendarEvent | ArticleSearchQuery_search_ItemSearchResults_results_CallOutSection | ArticleSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | ArticleSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder | ArticleSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_CallToAction | ArticleSearchQuery_search_ItemSearchResults_results_CallToActionFolder | ArticleSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Capability | ArticleSearchQuery_search_ItemSearchResults_results_CapabilityMap | ArticleSearchQuery_search_ItemSearchResults_results_CapabilityMappings | ArticleSearchQuery_search_ItemSearchResults_results_Carousel | ArticleSearchQuery_search_ItemSearchResults_results_CarouselFolder | ArticleSearchQuery_search_ItemSearchResults_results_CarouselSlide | ArticleSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | ArticleSearchQuery_search_ItemSearchResults_results_Checkbox | ArticleSearchQuery_search_ItemSearchResults_results_ChecklistFilter | ArticleSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | ArticleSearchQuery_search_ItemSearchResults_results_ColumnSplitter | ArticleSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | ArticleSearchQuery_search_ItemSearchResults_results_CompatibilityMode | ArticleSearchQuery_search_ItemSearchResults_results_ComponentConfiguration | ArticleSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | ArticleSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | ArticleSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations | ArticleSearchQuery_search_ItemSearchResults_results_ConfigurationFolder | ArticleSearchQuery_search_ItemSearchResults_results_Container | ArticleSearchQuery_search_ItemSearchResults_results_ContainerOption | ArticleSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder | ArticleSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | ArticleSearchQuery_search_ItemSearchResults_results_ContentBlock | ArticleSearchQuery_search_ItemSearchResults_results_ContentBlockFolder | ArticleSearchQuery_search_ItemSearchResults_results_ContentToken | ArticleSearchQuery_search_ItemSearchResults_results_ContentTokenFolder | ArticleSearchQuery_search_ItemSearchResults_results_ContentType | ArticleSearchQuery_search_ItemSearchResults_results_CorporateTheme | ArticleSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Country | ArticleSearchQuery_search_ItemSearchResults_results_CountryISOCode | ArticleSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder | ArticleSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder | ArticleSearchQuery_search_ItemSearchResults_results_CustomerReviewTile | ArticleSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeFund | ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass | ArticleSearchQuery_search_ItemSearchResults_results_DataFolder | ArticleSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration | ArticleSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations | ArticleSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | ArticleSearchQuery_search_ItemSearchResults_results_DateFacet | ArticleSearchQuery_search_ItemSearchResults_results_DateFilter | ArticleSearchQuery_search_ItemSearchResults_results_DateFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | ArticleSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout | ArticleSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping | ArticleSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings | ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight | ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | ArticleSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Device | ArticleSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | ArticleSearchQuery_search_ItemSearchResults_results_Devices | ArticleSearchQuery_search_ItemSearchResults_results_DictionaryFolder | ArticleSearchQuery_search_ItemSearchResults_results_DisqusParameters | ArticleSearchQuery_search_ItemSearchResults_results_DistanceFacet | ArticleSearchQuery_search_ItemSearchResults_results_Divider | ArticleSearchQuery_search_ItemSearchResults_results_DocumentItem | ArticleSearchQuery_search_ItemSearchResults_results_DocumentListings | ArticleSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping | ArticleSearchQuery_search_ItemSearchResults_results_Dropdown | ArticleSearchQuery_search_ItemSearchResults_results_DropdownFilter | ArticleSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | ArticleSearchQuery_search_ItemSearchResults_results_EditEditingTheme | ArticleSearchQuery_search_ItemSearchResults_results_EditFrame | ArticleSearchQuery_search_ItemSearchResults_results_EditModePanel | ArticleSearchQuery_search_ItemSearchResults_results_EditSiteItem | ArticleSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | ArticleSearchQuery_search_ItemSearchResults_results_EditSiteTheme | ArticleSearchQuery_search_ItemSearchResults_results_EditTenantTemplate | ArticleSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | ArticleSearchQuery_search_ItemSearchResults_results_EditType | ArticleSearchQuery_search_ItemSearchResults_results_EloquaFormFolder | ArticleSearchQuery_search_ItemSearchResults_results_EloquaFundForm | ArticleSearchQuery_search_ItemSearchResults_results_Enum | ArticleSearchQuery_search_ItemSearchResults_results_Enums | ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage | ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | ArticleSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | ArticleSearchQuery_search_ItemSearchResults_results_EventCalendarParameters | ArticleSearchQuery_search_ItemSearchResults_results_EventList | ArticleSearchQuery_search_ItemSearchResults_results_EventListParameters | ArticleSearchQuery_search_ItemSearchResults_results_EventTypes | ArticleSearchQuery_search_ItemSearchResults_results_EventsFolder | ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript | ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | ArticleSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | ArticleSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme | ArticleSearchQuery_search_ItemSearchResults_results_ExternalLiterature | ArticleSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_FacetSlider | ArticleSearchQuery_search_ItemSearchResults_results_FacetSliderFolder | ArticleSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | ArticleSearchQuery_search_ItemSearchResults_results_FacetSummary | ArticleSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder | ArticleSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | ArticleSearchQuery_search_ItemSearchResults_results_FacetsGrouping | ArticleSearchQuery_search_ItemSearchResults_results_FakeNavigationItem | ArticleSearchQuery_search_ItemSearchResults_results_FeatureBanner | ArticleSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_FeaturedArticles | ArticleSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | ArticleSearchQuery_search_ItemSearchResults_results_FeaturedTheme | ArticleSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Feed | ArticleSearchQuery_search_ItemSearchResults_results_FeedFolder | ArticleSearchQuery_search_ItemSearchResults_results_FeedParameters | ArticleSearchQuery_search_ItemSearchResults_results_FieldEditor | ArticleSearchQuery_search_ItemSearchResults_results_FieldRenderer | ArticleSearchQuery_search_ItemSearchResults_results_FileList | ArticleSearchQuery_search_ItemSearchResults_results_FileListFolder | ArticleSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | ArticleSearchQuery_search_ItemSearchResults_results_FilterCriteria | ArticleSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder | ArticleSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption | ArticleSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | ArticleSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | ArticleSearchQuery_search_ItemSearchResults_results_Flip | ArticleSearchQuery_search_ItemSearchResults_results_FlipFolder | ArticleSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | ArticleSearchQuery_search_ItemSearchResults_results_Flipside | ArticleSearchQuery_search_ItemSearchResults_results_FloatFacet | ArticleSearchQuery_search_ItemSearchResults_results_Footer | ArticleSearchQuery_search_ItemSearchResults_results_FooterFolder | ArticleSearchQuery_search_ItemSearchResults_results_FooterLink | ArticleSearchQuery_search_ItemSearchResults_results_FormRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_FundAssetClass | ArticleSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | ArticleSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | ArticleSearchQuery_search_ItemSearchResults_results_FundFormsFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundInFocus | ArticleSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass | ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | ArticleSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | ArticleSearchQuery_search_ItemSearchResults_results_FundSettings | ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | ArticleSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | ArticleSearchQuery_search_ItemSearchResults_results_FundSubAssetClass | ArticleSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundsFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder | ArticleSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_Gallery | ArticleSearchQuery_search_ItemSearchResults_results_GalleryFolder | ArticleSearchQuery_search_ItemSearchResults_results_GalleryImage | ArticleSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_GalleryVideo | ArticleSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer | ArticleSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector | ArticleSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar | ArticleSearchQuery_search_ItemSearchResults_results_GoogleAnalytics | ArticleSearchQuery_search_ItemSearchResults_results_GoogleTagManager | ArticleSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | ArticleSearchQuery_search_ItemSearchResults_results_GridSetup | ArticleSearchQuery_search_ItemSearchResults_results_GridTheme | ArticleSearchQuery_search_ItemSearchResults_results_HTMLCode | ArticleSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder | ArticleSearchQuery_search_ItemSearchResults_results_HTMLInclude | ArticleSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder | ArticleSearchQuery_search_ItemSearchResults_results_HTMLSnippet | ArticleSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder | ArticleSearchQuery_search_ItemSearchResults_results_HTMLTag | ArticleSearchQuery_search_ItemSearchResults_results_Header | ArticleSearchQuery_search_ItemSearchResults_results_HeaderFolder | ArticleSearchQuery_search_ItemSearchResults_results_Heading | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessVariants | ArticleSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePage | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleTag | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | ArticleSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | ArticleSearchQuery_search_ItemSearchResults_results_HelpTagMap | ArticleSearchQuery_search_ItemSearchResults_results_HelpTagMappings | ArticleSearchQuery_search_ItemSearchResults_results_HeroBanner | ArticleSearchQuery_search_ItemSearchResults_results_Highlight | ArticleSearchQuery_search_ItemSearchResults_results_HighlightBlock | ArticleSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder | ArticleSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_HighlightFolder | ArticleSearchQuery_search_ItemSearchResults_results_HighlightItem | ArticleSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Home | ArticleSearchQuery_search_ItemSearchResults_results_HomePage | ArticleSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | ArticleSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | ArticleSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | ArticleSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | ArticleSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | ArticleSearchQuery_search_ItemSearchResults_results_IFrame | ArticleSearchQuery_search_ItemSearchResults_results_IFrameFolder | ArticleSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | ArticleSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | ArticleSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | ArticleSearchQuery_search_ItemSearchResults_results_Icon | ArticleSearchQuery_search_ItemSearchResults_results_IconFolder | ArticleSearchQuery_search_ItemSearchResults_results_Image | ArticleSearchQuery_search_ItemSearchResults_results_ImageFolder | ArticleSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | ArticleSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | ArticleSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | ArticleSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | ArticleSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | ArticleSearchQuery_search_ItemSearchResults_results_Infographics | ArticleSearchQuery_search_ItemSearchResults_results_InfographicsFolder | ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep | ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | ArticleSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | ArticleSearchQuery_search_ItemSearchResults_results_IntegerFacet | ArticleSearchQuery_search_ItemSearchResults_results_IntroCopy | ArticleSearchQuery_search_ItemSearchResults_results_IntroCopyFolder | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle | ArticleSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | ArticleSearchQuery_search_ItemSearchResults_results_InvestorType | ArticleSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder | ArticleSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder | ArticleSearchQuery_search_ItemSearchResults_results_ItemRights | ArticleSearchQuery_search_ItemSearchResults_results_JSBeaconSettings | ArticleSearchQuery_search_ItemSearchResults_results_JSONCheckbox | ArticleSearchQuery_search_ItemSearchResults_results_JSONContent | ArticleSearchQuery_search_ItemSearchResults_results_JSONDate | ArticleSearchQuery_search_ItemSearchResults_results_JSONFile | ArticleSearchQuery_search_ItemSearchResults_results_JSONImage | ArticleSearchQuery_search_ItemSearchResults_results_JSONLayout | ArticleSearchQuery_search_ItemSearchResults_results_JSONList | ArticleSearchQuery_search_ItemSearchResults_results_JSONMultilistReference | ArticleSearchQuery_search_ItemSearchResults_results_JSONPlaceholder | ArticleSearchQuery_search_ItemSearchResults_results_JSONQuery | ArticleSearchQuery_search_ItemSearchResults_results_JSONResults | ArticleSearchQuery_search_ItemSearchResults_results_JSONRichText | ArticleSearchQuery_search_ItemSearchResults_results_JSONScriban | ArticleSearchQuery_search_ItemSearchResults_results_JSONSection | ArticleSearchQuery_search_ItemSearchResults_results_JSONTemplate | ArticleSearchQuery_search_ItemSearchResults_results_JSONText | ArticleSearchQuery_search_ItemSearchResults_results_JSONToken | ArticleSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition | ArticleSearchQuery_search_ItemSearchResults_results_JSONVariants | ArticleSearchQuery_search_ItemSearchResults_results_JSSLayout | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | ArticleSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | ArticleSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping | ArticleSearchQuery_search_ItemSearchResults_results_JSSTenantFolder | ArticleSearchQuery_search_ItemSearchResults_results_JavaScriptRendering | ArticleSearchQuery_search_ItemSearchResults_results_JsonRendering | ArticleSearchQuery_search_ItemSearchResults_results_JurisdictionStatus | ArticleSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder | ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlightItem | ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlights | ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder | ArticleSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Language | ArticleSearchQuery_search_ItemSearchResults_results_LanguageSelector | ArticleSearchQuery_search_ItemSearchResults_results_LanguagesFolder | ArticleSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants | ArticleSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder | ArticleSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption | ArticleSearchQuery_search_ItemSearchResults_results_Link | ArticleSearchQuery_search_ItemSearchResults_results_LinkList | ArticleSearchQuery_search_ItemSearchResults_results_LinkListFolder | ArticleSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | ArticleSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | ArticleSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | ArticleSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | ArticleSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | ArticleSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | ArticleSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | ArticleSearchQuery_search_ItemSearchResults_results_LinksFolder | ArticleSearchQuery_search_ItemSearchResults_results_List | ArticleSearchQuery_search_ItemSearchResults_results_ListFacet | ArticleSearchQuery_search_ItemSearchResults_results_ListFolder | ArticleSearchQuery_search_ItemSearchResults_results_ListItem | ArticleSearchQuery_search_ItemSearchResults_results_ListParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_ListStyle | ArticleSearchQuery_search_ItemSearchResults_results_ListStyleItem | ArticleSearchQuery_search_ItemSearchResults_results_ListingHeroBanner | ArticleSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization | ArticleSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | ArticleSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | ArticleSearchQuery_search_ItemSearchResults_results_LoadMore | ArticleSearchQuery_search_ItemSearchResults_results_LoadMoreFolder | ArticleSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | ArticleSearchQuery_search_ItemSearchResults_results_LocationFilter | ArticleSearchQuery_search_ItemSearchResults_results_LocationFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | ArticleSearchQuery_search_ItemSearchResults_results_Log | ArticleSearchQuery_search_ItemSearchResults_results_Login | ArticleSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | ArticleSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem | ArticleSearchQuery_search_ItemSearchResults_results_LogoTextBlocks | ArticleSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | ArticleSearchQuery_search_ItemSearchResults_results_Logout | ArticleSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter | ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | ArticleSearchQuery_search_ItemSearchResults_results_ManagedRangeItem | ArticleSearchQuery_search_ItemSearchResults_results_Map | ArticleSearchQuery_search_ItemSearchResults_results_MapParameters | ArticleSearchQuery_search_ItemSearchResults_results_MapsFolder | ArticleSearchQuery_search_ItemSearchResults_results_MapsProvider | ArticleSearchQuery_search_ItemSearchResults_results_MediaBlock | ArticleSearchQuery_search_ItemSearchResults_results_MediaBlockFolder | ArticleSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | ArticleSearchQuery_search_ItemSearchResults_results_MediaLinkParameters | ArticleSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder | ArticleSearchQuery_search_ItemSearchResults_results_MegaNavigation | ArticleSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder | ArticleSearchQuery_search_ItemSearchResults_results_MetaBranding | ArticleSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters | ArticleSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign | ArticleSearchQuery_search_ItemSearchResults_results_Model | ArticleSearchQuery_search_ItemSearchResults_results_ModelIterator | ArticleSearchQuery_search_ItemSearchResults_results_MyLocationPOI | ArticleSearchQuery_search_ItemSearchResults_results_Navigation | ArticleSearchQuery_search_ItemSearchResults_results_NavigationCategory | ArticleSearchQuery_search_ItemSearchResults_results_NavigationFilter | ArticleSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_NavigationLink | ArticleSearchQuery_search_ItemSearchResults_results_NavigationSubcategory | ArticleSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | ArticleSearchQuery_search_ItemSearchResults_results_OneTrustSettings | ArticleSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration | ArticleSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | ArticleSearchQuery_search_ItemSearchResults_results_OptimizedFile | ArticleSearchQuery_search_ItemSearchResults_results_OracleCDPSettings | ArticleSearchQuery_search_ItemSearchResults_results_OverlayContent | ArticleSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Ownership | ArticleSearchQuery_search_ItemSearchResults_results_OwnershipFolder | ArticleSearchQuery_search_ItemSearchResults_results_POI | ArticleSearchQuery_search_ItemSearchResults_results_POIFolder | ArticleSearchQuery_search_ItemSearchResults_results_POIType | ArticleSearchQuery_search_ItemSearchResults_results_POIs | ArticleSearchQuery_search_ItemSearchResults_results_PageBranchesFolder | ArticleSearchQuery_search_ItemSearchResults_results_PageContent | ArticleSearchQuery_search_ItemSearchResults_results_PageContentFolder | ArticleSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesign | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | ArticleSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | ArticleSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | ArticleSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | ArticleSearchQuery_search_ItemSearchResults_results_PageLevelTabs | ArticleSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder | ArticleSearchQuery_search_ItemSearchResults_results_PageList | ArticleSearchQuery_search_ItemSearchResults_results_PageSelector | ArticleSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration | ArticleSearchQuery_search_ItemSearchResults_results_PageSelectorFolder | ArticleSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | ArticleSearchQuery_search_ItemSearchResults_results_PageSize | ArticleSearchQuery_search_ItemSearchResults_results_PageSizeFolder | ArticleSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | ArticleSearchQuery_search_ItemSearchResults_results_PageTheme | ArticleSearchQuery_search_ItemSearchResults_results_PageThemesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | ArticleSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | ArticleSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | ArticleSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | ArticleSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | ArticleSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | ArticleSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | ArticleSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | ArticleSearchQuery_search_ItemSearchResults_results_Pagging | ArticleSearchQuery_search_ItemSearchResults_results_Pagination | ArticleSearchQuery_search_ItemSearchResults_results_PaginationFolder | ArticleSearchQuery_search_ItemSearchResults_results_Paragraph | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | ArticleSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | ArticleSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings | ArticleSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | ArticleSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | ArticleSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | ArticleSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | ArticleSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | ArticleSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | ArticleSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | ArticleSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Playlist | ArticleSearchQuery_search_ItemSearchResults_results_PlaylistFolder | ArticleSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Podcast | ArticleSearchQuery_search_ItemSearchResults_results_PodcastFolder | ArticleSearchQuery_search_ItemSearchResults_results_PodcastPage | ArticleSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage | ArticleSearchQuery_search_ItemSearchResults_results_PoiTypes | ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep | ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | ArticleSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep | ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | ArticleSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | ArticleSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | ArticleSearchQuery_search_ItemSearchResults_results_Presentation | ArticleSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseContentType | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseFilter | ArticleSearchQuery_search_ItemSearchResults_results_PressReleasePage | ArticleSearchQuery_search_ItemSearchResults_results_PressReleasePlatform | ArticleSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | ArticleSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | ArticleSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | ArticleSearchQuery_search_ItemSearchResults_results_PrivacyWarning | ArticleSearchQuery_search_ItemSearchResults_results_ProjectFolder | ArticleSearchQuery_search_ItemSearchResults_results_Promo | ArticleSearchQuery_search_ItemSearchResults_results_PromoFolder | ArticleSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | ArticleSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | ArticleSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | ArticleSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | ArticleSearchQuery_search_ItemSearchResults_results_PromotedContent | ArticleSearchQuery_search_ItemSearchResults_results_PromotedContentFolder | ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingCard | ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingCards | ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingCategory | ArticleSearchQuery_search_ItemSearchResults_results_PropertyListingFolder | ArticleSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | ArticleSearchQuery_search_ItemSearchResults_results_QuickLinks | ArticleSearchQuery_search_ItemSearchResults_results_QuickLinksFolder | ArticleSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlockItem | ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlocks | ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder | ArticleSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Quote | ArticleSearchQuery_search_ItemSearchResults_results_QuoteFolder | ArticleSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_RadiusFilter | ArticleSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | ArticleSearchQuery_search_ItemSearchResults_results_RadiusScheme | ArticleSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue | ArticleSearchQuery_search_ItemSearchResults_results_RangeSliderFilter | ArticleSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | ArticleSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | ArticleSearchQuery_search_ItemSearchResults_results_RecentArticles | ArticleSearchQuery_search_ItemSearchResults_results_Redirect | ArticleSearchQuery_search_ItemSearchResults_results_RedirectMap | ArticleSearchQuery_search_ItemSearchResults_results_RedirectMaps | ArticleSearchQuery_search_ItemSearchResults_results_Region | ArticleSearchQuery_search_ItemSearchResults_results_RegionLanguages | ArticleSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder | ArticleSearchQuery_search_ItemSearchResults_results_RelatedArticles | ArticleSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_RenderEngineType | ArticleSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | ArticleSearchQuery_search_ItemSearchResults_results_RenderingHost | ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage | ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | ArticleSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | ArticleSearchQuery_search_ItemSearchResults_results_ResponsiveImage | ArticleSearchQuery_search_ItemSearchResults_results_ResultsCount | ArticleSearchQuery_search_ItemSearchResults_results_ResultsCountFolder | ArticleSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | ArticleSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector | ArticleSearchQuery_search_ItemSearchResults_results_RichText | ArticleSearchQuery_search_ItemSearchResults_results_RichTextFolder | ArticleSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | ArticleSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | ArticleSearchQuery_search_ItemSearchResults_results_RiskImageMapping | ArticleSearchQuery_search_ItemSearchResults_results_RiskImageMappings | ArticleSearchQuery_search_ItemSearchResults_results_RiskLevelOption | ArticleSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | ArticleSearchQuery_search_ItemSearchResults_results_RiskWarning | ArticleSearchQuery_search_ItemSearchResults_results_RiskWarningFolder | ArticleSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_RolePlaceholder | ArticleSearchQuery_search_ItemSearchResults_results_RowSplitter | ArticleSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | ArticleSearchQuery_search_ItemSearchResults_results_Rule | ArticleSearchQuery_search_ItemSearchResults_results_SDRLogoMapping | ArticleSearchQuery_search_ItemSearchResults_results_SDRLogoMappings | ArticleSearchQuery_search_ItemSearchResults_results_SDRTypeOption | ArticleSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | ArticleSearchQuery_search_ItemSearchResults_results_SXAJSSLayout | ArticleSearchQuery_search_ItemSearchResults_results_SXARole | ArticleSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceDateInput | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceDropdown | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceInput | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceInputType | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceSection | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | ArticleSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType | ArticleSearchQuery_search_ItemSearchResults_results_Scope | ArticleSearchQuery_search_ItemSearchResults_results_ScopesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Scriban | ArticleSearchQuery_search_ItemSearchResults_results_Scripts | ArticleSearchQuery_search_ItemSearchResults_results_SearchBox | ArticleSearchQuery_search_ItemSearchResults_results_SearchBoxFolder | ArticleSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | ArticleSearchQuery_search_ItemSearchResults_results_SearchFolder | ArticleSearchQuery_search_ItemSearchResults_results_SearchResults | ArticleSearchQuery_search_ItemSearchResults_results_SearchResultsFolder | ArticleSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | ArticleSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_SectionHeading | ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder | ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingType | ArticleSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_SectionSelector | ArticleSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder | ArticleSearchQuery_search_ItemSearchResults_results_SectionSelectorTab | ArticleSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | ArticleSearchQuery_search_ItemSearchResults_results_Series | ArticleSearchQuery_search_ItemSearchResults_results_SeriesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Settings | ArticleSearchQuery_search_ItemSearchResults_results_SettingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | ArticleSearchQuery_search_ItemSearchResults_results_SharePriceSettings | ArticleSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder | ArticleSearchQuery_search_ItemSearchResults_results_SharedContentFolder | ArticleSearchQuery_search_ItemSearchResults_results_SharedFolder | ArticleSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | ArticleSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | ArticleSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder | ArticleSearchQuery_search_ItemSearchResults_results_SharedSitesSettings | ArticleSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | ArticleSearchQuery_search_ItemSearchResults_results_Showcase | ArticleSearchQuery_search_ItemSearchResults_results_ShowcaseFolder | ArticleSearchQuery_search_ItemSearchResults_results_ShowcaseItem | ArticleSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Site | ArticleSearchQuery_search_ItemSearchResults_results_SiteContentFolder | ArticleSearchQuery_search_ItemSearchResults_results_SiteDefinition | ArticleSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | ArticleSearchQuery_search_ItemSearchResults_results_SiteFolder | ArticleSearchQuery_search_ItemSearchResults_results_SiteGrouping | ArticleSearchQuery_search_ItemSearchResults_results_SiteManagement | ArticleSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | ArticleSearchQuery_search_ItemSearchResults_results_SiteSelector | ArticleSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | ArticleSearchQuery_search_ItemSearchResults_results_SiteSetupRoot | ArticleSearchQuery_search_ItemSearchResults_results_SiteTheme | ArticleSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | ArticleSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_SitecoreRole | ArticleSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | ArticleSearchQuery_search_ItemSearchResults_results_SkipLink | ArticleSearchQuery_search_ItemSearchResults_results_SkipLinkParameters | ArticleSearchQuery_search_ItemSearchResults_results_SkipLinksFolder | ArticleSearchQuery_search_ItemSearchResults_results_Snippet | ArticleSearchQuery_search_ItemSearchResults_results_SnippetItem | ArticleSearchQuery_search_ItemSearchResults_results_SnippetsFolder | ArticleSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper | ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaButtons | ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaFolder | ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaShare | ArticleSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate | ArticleSearchQuery_search_ItemSearchResults_results_SocialNetwork | ArticleSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder | ArticleSearchQuery_search_ItemSearchResults_results_SocialNetworkLink | ArticleSearchQuery_search_ItemSearchResults_results_SolutionTemplate | ArticleSearchQuery_search_ItemSearchResults_results_SortResults | ArticleSearchQuery_search_ItemSearchResults_results_SortResultsFolder | ArticleSearchQuery_search_ItemSearchResults_results_Sorting | ArticleSearchQuery_search_ItemSearchResults_results_SortingGroups | ArticleSearchQuery_search_ItemSearchResults_results_SpotifyPodcast | ArticleSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | ArticleSearchQuery_search_ItemSearchResults_results_StickyCTA | ArticleSearchQuery_search_ItemSearchResults_results_StickyCTAFolder | ArticleSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | ArticleSearchQuery_search_ItemSearchResults_results_StrategyInFocus | ArticleSearchQuery_search_ItemSearchResults_results_Style | ArticleSearchQuery_search_ItemSearchResults_results_Styles | ArticleSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | ArticleSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Tab | ArticleSearchQuery_search_ItemSearchResults_results_TabItem | ArticleSearchQuery_search_ItemSearchResults_results_TableOfContents | ArticleSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder | ArticleSearchQuery_search_ItemSearchResults_results_TableOfContentsSection | ArticleSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection | ArticleSearchQuery_search_ItemSearchResults_results_Tabs | ArticleSearchQuery_search_ItemSearchResults_results_TabsFolder | ArticleSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | ArticleSearchQuery_search_ItemSearchResults_results_Tag | ArticleSearchQuery_search_ItemSearchResults_results_TagCloud | ArticleSearchQuery_search_ItemSearchResults_results_TagFolder | ArticleSearchQuery_search_ItemSearchResults_results_TagList | ArticleSearchQuery_search_ItemSearchResults_results_TeamBiographySettings | ArticleSearchQuery_search_ItemSearchResults_results_TeamListingCards | ArticleSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder | ArticleSearchQuery_search_ItemSearchResults_results_TeamMember | ArticleSearchQuery_search_ItemSearchResults_results_TeamMemberCard | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembers | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | ArticleSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | ArticleSearchQuery_search_ItemSearchResults_results_TeamProfileCards | ArticleSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | ArticleSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage | ArticleSearchQuery_search_ItemSearchResults_results_Tenant | ArticleSearchQuery_search_ItemSearchResults_results_TenantFolder | ArticleSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | ArticleSearchQuery_search_ItemSearchResults_results_TenantSetupRoot | ArticleSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner | ArticleSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Text | ArticleSearchQuery_search_ItemSearchResults_results_TextBlock | ArticleSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType | ArticleSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_TextBlockLinkType | ArticleSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | ArticleSearchQuery_search_ItemSearchResults_results_TextBlocks | ArticleSearchQuery_search_ItemSearchResults_results_TextBlocksFolder | ArticleSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_TextFolder | ArticleSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | ArticleSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | ArticleSearchQuery_search_ItemSearchResults_results_Theme | ArticleSearchQuery_search_ItemSearchResults_results_ThemeTag | ArticleSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder | ArticleSearchQuery_search_ItemSearchResults_results_ThemingMode | ArticleSearchQuery_search_ItemSearchResults_results_ThemingModes | ArticleSearchQuery_search_ItemSearchResults_results_Tile | ArticleSearchQuery_search_ItemSearchResults_results_TileLink | ArticleSearchQuery_search_ItemSearchResults_results_TileParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_TileSizeOption | ArticleSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder | ArticleSearchQuery_search_ItemSearchResults_results_TilesFolder | ArticleSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Title | ArticleSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | ArticleSearchQuery_search_ItemSearchResults_results_Toggle | ArticleSearchQuery_search_ItemSearchResults_results_ToggleFolder | ArticleSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | ArticleSearchQuery_search_ItemSearchResults_results_Transformation | ArticleSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_TrustFinder | ArticleSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption | ArticleSearchQuery_search_ItemSearchResults_results_TrustRegion | ArticleSearchQuery_search_ItemSearchResults_results_TrustType | ArticleSearchQuery_search_ItemSearchResults_results_TrustTypesFolder | ArticleSearchQuery_search_ItemSearchResults_results_Twitter | ArticleSearchQuery_search_ItemSearchResults_results_TwitterApp | ArticleSearchQuery_search_ItemSearchResults_results_TwitterApps | ArticleSearchQuery_search_ItemSearchResults_results_TwitterFolder | ArticleSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_TwitterSettings | ArticleSearchQuery_search_ItemSearchResults_results_UnknownItem | ArticleSearchQuery_search_ItemSearchResults_results_UnminifiedFile | ArticleSearchQuery_search_ItemSearchResults_results_UpgradeScript | ArticleSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | ArticleSearchQuery_search_ItemSearchResults_results_VariantComponentField | ArticleSearchQuery_search_ItemSearchResults_results_VariantDateField | ArticleSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | ArticleSearchQuery_search_ItemSearchResults_results_VariantPlaceholder | ArticleSearchQuery_search_ItemSearchResults_results_VariantReference | ArticleSearchQuery_search_ItemSearchResults_results_VariantSection | ArticleSearchQuery_search_ItemSearchResults_results_VariantTemplate | ArticleSearchQuery_search_ItemSearchResults_results_VariantText | ArticleSearchQuery_search_ItemSearchResults_results_VariantToken | ArticleSearchQuery_search_ItemSearchResults_results_Variants | ArticleSearchQuery_search_ItemSearchResults_results_VectorFolder | ArticleSearchQuery_search_ItemSearchResults_results_VectorTile | ArticleSearchQuery_search_ItemSearchResults_results_VectorTileLink | ArticleSearchQuery_search_ItemSearchResults_results_VectorTilesFolder | ArticleSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | ArticleSearchQuery_search_ItemSearchResults_results_Video | ArticleSearchQuery_search_ItemSearchResults_results_VideoCountOption | ArticleSearchQuery_search_ItemSearchResults_results_VideoCountOptions | ArticleSearchQuery_search_ItemSearchResults_results_VideoFolder | ArticleSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | ArticleSearchQuery_search_ItemSearchResults_results_VideoPage | ArticleSearchQuery_search_ItemSearchResults_results_VideoParameters | ArticleSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate | ArticleSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage | ArticleSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | ArticleSearchQuery_search_ItemSearchResults_results__AssetsOptimization | ArticleSearchQuery_search_ItemSearchResults_results__BackgroundImage | ArticleSearchQuery_search_ItemSearchResults_results__CompatibleThemes | ArticleSearchQuery_search_ItemSearchResults_results__CompositeTheme | ArticleSearchQuery_search_ItemSearchResults_results__CustomMetadata | ArticleSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath | ArticleSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour | ArticleSearchQuery_search_ItemSearchResults_results__Favicon | ArticleSearchQuery_search_ItemSearchResults_results__FormsFolderLocation | ArticleSearchQuery_search_ItemSearchResults_results__FundSettings | ArticleSearchQuery_search_ItemSearchResults_results__HasValidUrlName | ArticleSearchQuery_search_ItemSearchResults_results__LocalDataLink | ArticleSearchQuery_search_ItemSearchResults_results__Login | ArticleSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata | ArticleSearchQuery_search_ItemSearchResults_results__PageDesignTheme | ArticleSearchQuery_search_ItemSearchResults_results__PageSearchScope | ArticleSearchQuery_search_ItemSearchResults_results__SearchCriteria | ArticleSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | ArticleSearchQuery_search_ItemSearchResults_results__SeoMetadata | ArticleSearchQuery_search_ItemSearchResults_results__SiteTheme | ArticleSearchQuery_search_ItemSearchResults_results__SitemapSettings | ArticleSearchQuery_search_ItemSearchResults_results__StickyNote | ArticleSearchQuery_search_ItemSearchResults_results__Styleable | ArticleSearchQuery_search_ItemSearchResults_results__TwitterMetadata | ArticleSearchQuery_search_ItemSearchResults_results__Webinar | ArticleSearchQuery_search_ItemSearchResults_results__WildcardSource;

export type ArticleSearchQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: ArticleSearchQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<ArticleSearchQuery_search_ItemSearchResults_results>> }
);

export type ArticleSearchQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<ArticleSearchQuery_search_ItemSearchResults> }
);


export type ArticleSearchQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  pageHash: Types.InputMaybe<Types.Scalars['String']['input']>;
  articleName: Types.InputMaybe<Types.Scalars['String']['input']>;
  language: Types.InputMaybe<Types.Scalars['String']['input']>;
  siteId: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ArticleSearchQuery = ArticleSearchQuery_Query;


export const ArticleSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageHash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"2567876566B044428C3DB5C9D0E53D76","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"70945527D09E4CC5A30A364324CBFCCF","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQ"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"shareTo","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageHash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rendered"}}]}}]}}]}}]} as unknown as DocumentNode<ArticleSearchQuery, ArticleSearchQueryVariables>;